// extracted by mini-css-extract-plugin
export var displayNone = "_r9-6";
export var imgContainer = "_r9-2";
export var overflowHidden = "_r9-3";
export var productInfoCardButtonContainer = "_r9-5";
export var productTitleText = "_r9-4";
export var rightArrow = "_r9-1";
export var rightArrowContainer = "_r9-0";